
export default {
  // Navigation-related translations
  "home": "Início",
  "profile": "Perfil",
  "airports": "Aeroportos",
  "inventory": "Inventário",
  "admin": "Admin",
  "resources": "Recursos",
  "develop": "Revelação",
  "sign_in": "Entrar",
  "sign_up": "Cadastrar",
  // "light_meter": "Fotômetro" // Commented out to hide from navigation
};
